import { isErrorWithMessage } from "./isErrorWithMessage";
import { ErrorWithMessage } from "./types";

export const toErrorWithMessage = (maybeError: unknown): ErrorWithMessage => {
	if (isErrorWithMessage(maybeError))
		return maybeError;

	try {
		return new Error(JSON.stringify(maybeError));
	} catch (e) {
		return new Error(String(maybeError), { cause: e });
	}
};